export const COMMERCIAL_ROLE_ID = 5;
export const COMPTABLE_ROLE_ID = 6;
export const ALL_ACCESS_ROLE_ID = 2;
export const APP_VERSION = "v1.1.0";

// CLASS [NUMBER] PLAN COMPTABLE TYPE DANS LA DB
export const CLASS_1_PC_TYPE="Comptes de Financement Permanent (classe 1)";
export const CLASS_2_PC_TYPE="Comptes d'Actif Immobilisé (classe 2)";
export const CLASS_3_PC_TYPE="Comptes d'actif Circulation (Hors Trésorerie) (classe 3)";
export const CLASS_4_PC_TYPE="Comptes de passif circulant (Hors trésorerie) (classe 4)";
export const CLASS_5_PC_TYPE="Comptes de trésorerie (classe 5)";
export const CLASS_6_PC_TYPE="Charges (classe 6)";
export const CLASS_7_PC_TYPE="Comptes de produits (classe 7)";

export const PACK_BASIC_ORGS=1;
export const PACK_STANDARD_ORGS=3;
export const PACK_PREMIUM_ORGS=5;

export const PACK_BASIC_MEMBERS=3;
export const PACK_STANDARD_MEMBERS=5;
export const PACK_PREMIUM_MEMBERS=10;

export const HAD_ADD_ACCESS=true;
export const HAD_EDIT_ACCESS=true;
export const HAD_DELETE_ACCESS=true;